import { MdrSecurityTelemetryExclusionsGridWebComponent } from './component/MdrSecurityTelemetryExclusionsGridWebComponent';
import { WEB_COMPONENT_MDR_SECURITY_TELEMETRY_EXCLUSIONS_GRID } from '../../webcomponents.constants';

export { MdrSecurityTelemetryExclusionsGridWebComponent };

window.customElements.define(
  WEB_COMPONENT_MDR_SECURITY_TELEMETRY_EXCLUSIONS_GRID,
  MdrSecurityTelemetryExclusionsGridWebComponent
);
